import { LocationOn } from '@mui/icons-material';
import { Avatar, Badge, Box, Chip, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { Location, Position } from '../Types/Types';
import { getTimestamp } from '../Types/Utility';

interface Props {
    location: Location,
    coords: Position | null,
    minimalList?: boolean,
    hideAvatar?: boolean,
}
function LocationListItem(props : Props) {
    const { location, coords, minimalList = false, hideAvatar = false } = props;

    const distance = (loc : Location) => {
        if (coords) {    
            const R = 6371e3; // metres
            const φ1 = loc.lat * Math.PI/180; // φ, λ in radians
            const φ2 = coords.lat * Math.PI/180;
            const Δφ = (coords.lat-loc.lat) * Math.PI/180;
            const Δλ = (coords.lng-loc.lng) * Math.PI/180;
    
            const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                    Math.cos(φ1) * Math.cos(φ2) *
                    Math.sin(Δλ/2) * Math.sin(Δλ/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    
            const d = R * c;
            
            var distance = "";
            if (d < 50) {
                distance = "Hier";
            } else {
                if (d > 1000) {
                    distance = (d / 1000).toFixed(1) + "km";
                } else {
                    distance = d.toFixed(1) + "m";
                }
            }
            return <Box title={d.toFixed(1) + "m entfernt"}>
                <Chip icon={<LocationOn />} label={distance} size={"small"} sx={{ background: 'transparent' }}/>
            </Box>;
        }
        return <Box title="Entfernung kann nicht berechnet werden">
            <Chip icon={<LocationOn />} label={"---"} size={"small"}/>
        </Box>;
    }

    const getAvatar = (loc : Location) => {
        if (loc.image.startsWith('hoff')) {
            return process.env.PUBLIC_URL + '/img/' + loc.image;
        }
        return process.env.PUBLIC_URL + '/awards/' + loc.image;
    }

    const getName = (loc : Location) => {
        return <Typography variant={'body1'}>{loc.username}</Typography>;
    }

    return (
        <React.Fragment>
            {minimalList === false && <ListItemAvatar sx={{ minWidth: '55px' }}>
                {hideAvatar === false && <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    badgeContent={location.user_rank}
                    color={"success"}
                    sx={{ fontWeight: 'bold' }}
                >
                    <Avatar src={getAvatar(location)}/>
                    <Box sx={{ position: 'absolute', bottom: '-10px', left: 0, width: '100%', display: 'grid', placeItems: 'center' }}>
                        {location.group_id && <Chip label={location.group_shorthand} color="primary" size="small" sx={{ borderRadius: '3px', fontSize: '0.65em', textTransform: 'uppercase', height: '16px' }}/>}
                    </Box>
                </Badge>}
            </ListItemAvatar>}
            <Box sx={{ display: 'flex', width: '100%' }}>
                <Box flexGrow={1}>
                    <ListItemText
                        primary={(minimalList || hideAvatar) ? '' : getName(location)}
                        secondary={getTimestamp(location.timestamp.toString())}
                        secondaryTypographyProps={{ color: 'primary' }}
                    />
                </Box>
                {coords && <Box flexShrink={1} alignSelf={"end"} sx={{ marginLeft: 1 }}>
                    {distance(location)}
                </Box>}
            </Box>
        </React.Fragment>
    );
}

export default LocationListItem;